import XxmiDatePicker from './src/xxmi-date-picker.vue';

XxmiDatePicker.install = function (Vue) {
  Vue.component(XxmiDatePicker.name, XxmiDatePicker);
};

export default XxmiDatePicker;